import React,{useState} from 'react';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import { useSelector } from 'react-redux';
import { pushBookingForgotPassword } from '../../gtm';


const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#FCFDFD',
  },
  title: {
    textAlign: 'center',
    color: '#444',
    fontSize: '18px',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: 'bold',
  },
  title2: {
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: '700',
    color: '#333',
    fontFamily: 'Nexa,sans-serif',
    lineHeight: '1.1',
  },
  title3: {
    textAlign: 'center',
    color: '#444',
    fontSize:'26px',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: 'bold',
  },
  subtitle: {
    textAlign: 'left',
    font: '14px arial,serif',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    marginTop: '20px',
  },
  button1: {
    backgroundColor: 'rgb(17, 137, 17)',
    color: 'rgb(255, 255, 255)',
    borderRadius: '6px',
    marginTop: '28px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: 'bold',
    fontSize: '1rem',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
  },
  spacing: {
    marginTop: '16px',
  },
});


const ForgotPassword = ({ classes }) => {

  

  const apiBaseUrlAPI1 = process.env.REACT_APP_API_BASE_URL;

  const legacyUrl = process.env.REACT_APP_FRONTEND_BOOKING_URL1;

  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [resendClicked, setResendClicked] = useState(false);
  const createBookingResponse = useSelector(state => state.createBooking);


  const handleRestore = async (event) => {
    const data = new FormData(event.currentTarget);


     // Gather Booking Forgot Password for GTM
     const bookingForgotPasswordDetails = {
      'DLV - TY - Email': data.get('loginEmail')
    };

    // Push the Booking Forgot Password to the data layer
    pushBookingForgotPassword(bookingForgotPasswordDetails);

    // Send the API request to send the password reset email
    try {
      // Your API request code here
      // Upon successful response, set the state to indicate email sent
      // Get form data
   

   event.preventDefault();

   const email = data.get('loginEmail')
  
   const bodyData =`{
    "basket": {
      "id": "${createBookingResponse.basket.id}"
    },
    "user": {
      "username": "${email}",
      "url": "${legacyUrl}"
    }
  }`

     const headers = {
       'Content-Type': 'application/json'
     };
     fetch(`${apiBaseUrlAPI1}/user/remind`, {
       method: 'POST',
       headers,
       body:bodyData,
     })
       .then((response) => response.json())
       .then((data) => {
        //  console.log(data)
         setEmailSent(true);
       })
       .catch((error) => {
        //  console.log('Error fetching drop-off options:', error);
       });

      
    } catch (error) {
      // console.error(error);
    }
  };

  const handleResend = () => {
    setEmailSent(false);
    setResendClicked(false);
  };


 
  
  
  

  return (
    <div>
      <Grid container spacing={2} className={`${classes.root} ${classes.spacing}`} style={{ textAlign: 'center'}}>
       

        {/* SIGNIN */}
        
        <Grid item xs={12} md={12} >
                <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                    >
                    
                    <Typography variant="h2" className={`${classes.title2} ${classes.spacing}`}>
                      Forgotten Your Password?
                    </Typography>
                    
                    {emailSent ? (
                        <div>
                          <p>An email with instructions on how to reset your password has been sent.</p>
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                  type="submit"
                                  variant="contained"
                                  sx={{ mt: 3, mb: 2 }}
                                  className={classes.button1}
                                  style={{ display: 'flex', justifyContent: 'center' }}
                                  onClick={() => {
                                    handleResend();
                                  }}
                                >
                                  Resend Email?
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <Box component="form" onSubmit={handleRestore} noValidate sx={{ mt: 1 }}>
                            <TextField
                              margin="normal"
                              required
                              fullWidth
                              id="loginEmail"
                              label="Username (Usually Email Address)"
                              name="loginEmail"
                              autoComplete="loginEmail"
                              autoFocus
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />

                            <Typography variant="p">
                              Please enter your username, and we'll send you an email to reset your password.
                            </Typography>

                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                              <Button
                                type="submit"
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                className={classes.button1}
                                style={{ display: 'flex', justifyContent: 'center' }}
                              >
                                Restore
                              </Button>
                            </div>
                          </Box>
                        </div>
                      )}
                      {resendClicked && !emailSent && (
                        <div>
                          <p>Resending email...</p>
                        </div>
                      )}
            </Box>
         </Container>
        </Grid>
      </Grid>
      
          
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(ForgotPassword);
